<template>
  <!-- 半日休取得可 -->
  <!-- 雇用契約の勤務時間が７時間以上が対象 -->
  <div class="flex">
    <div class="item kubun">
      <b class="required">区分</b>
      <select-box :options="OptionConst.SHINSEI_DIV_OPTION" v-model="koukyuu.koukyuu_tani_type"
        @update:modelValue="change" :error="getError(koukyuu, 'koukyuu_tani_type')"></select-box>
    </div>
    <div class="item date">
      <b class="required">取得日</b>
      <date-picker v-model="koukyuu.koukyuu_date" :error="getError(koukyuu, 'koukyuu_date')"
        @update:modelValue="change"></date-picker>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useForm } from "@/composable/form/form";
import OptionConst from '@/const/Option';
import { KoukyuuData } from '@/types/Shinsei';
import KoyouKeiyakuTImeSelect from "@/components/shinsei/create/parts/KoyouKeiyakuTimeSelect.vue"

export default defineComponent({
  props: {
    koukyuuList: {
      type: Object as () => KoukyuuData[],
      default: null
    },
    koukyuu: {
      type: Object as () => KoukyuuData,
      default: null
    },
  },
  emits: {
    change: () => true,
  },
  setup(props, context) {
    const { getError } = useForm();

    const change = () => {
      context.emit('change');
    }

    return {
      OptionConst,
      getError,
      change,
    };
  },
  components: {
    'koyouKeiyakuTimeSelect': KoyouKeiyakuTImeSelect
  }
});
</script>

<style lang="scss" scoped>
@import '@scss/components/shinsei-create.scss';
</style>
